<template>
  <div class="conditions-box">
    <diV class="conditions-box-shadow">
    </diV>
    <div class="conditions-box-content container">
      <div class="row condition-box-header">
        <div class="col-md-12">
          <i class="fas fa-check mr-2"></i><b>選択中の条件</b>
        </div>
        <div class="col-md-12">
          <hr class="condition-box-hr">
        </div>
      </div>
      <selected-condition-line
        v-if="conditions.cities && conditions.cities.length > 0"
        label="所在地"
        :items="conditions.cities.map(x => `${x.prefecture_name}/${x.name}`)"
      />
      <selected-condition-line
        v-if="conditions.facility_types && conditions.facility_types.length > 0"
        label="施設"
        :items="conditions.facility_types.map(x => `${x.name}`)"
      />
      <selected-condition-line
        v-if="conditions.sports_types && conditions.sports_types.length > 0"
        label="競技"
        :items="conditions.sports_types.map(x => `${x.name}`)"
      />
      <selected-condition-line
        v-if="conditions.price_ranges && conditions.price_ranges.length > 0"
        label="料金"
        :items="conditions.price_ranges.map(x => `${x.price_use_unit_name}/${x.name}`)"
      />
      <selected-condition-line
        v-if="conditions.tags && conditions.tags.length > 0"
        label="タグ"
        :items="conditions.tags.map(x => `${x.name}`)"
      />
      <selected-condition-line
        v-if="displayConditionAvailability"
        :label="isNoSearchAvailability ? '期間' : '空き有り'"
        :items="conditions.availabilities.length > 0 ? conditions.availabilities.map(x => `${x.name}`) : ['日時指定なし']"
      />
    </div>
  </div>
</template>
<script>
import selectedConditionLine from './selectedConditionLine.vue'
export default {
  data() {
    return {
  
    }
  },
  props: {
    conditions: {
      type: Object,
      default: {}
    },
    displayConditionAvailability: {
      type: Boolean,
      default: true
    },
    isNoSearchAvailability: {
      type: Boolean,
      default: false
    }
  },
  components: {
    selectedConditionLine
  },
  methods: {
    
  },
  created(){
    
  },
  computed: {
    
  },
  watch: {
    
  }
}
</script>